(() => {
  if (window.mfWishlistReady) return;
  const configNode = document.getElementById('mf-wishlist-config');
  if (!configNode) return;
  window.mfWishlistReady = true;
  const config = JSON.parse(configNode.textContent);
  const s = config.strings;
  const key = 'river:wishlist:v1';
  const dialog = document.getElementById('mf-wishlist-dialog');
  const list = dialog.querySelector('[data-mf-list]');
  const status = dialog.querySelector('[data-mf-list-status]');
  const live = document.getElementById('mf-wishlist-status');
  const root = config.root.replace(/\/?$/, '/');
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const decode = value => {
    try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? [...new Set(parsed.filter(validHandle))].slice(0, 200) : []; }
    catch { return []; }
  };
  let saved = [];
  try { saved = decode(localStorage.getItem(key)); } catch {}
  let shared = null;
  const title = document.getElementById('mf-wishlist-title');
  const ownTitle = title?.textContent;
  const shareButton = dialog.querySelector('[data-mf-share]');
  const ownButton = dialog.querySelector('[data-mf-own]');
  const shareFallback = dialog.querySelector('[data-mf-share-fallback]');
  const shareInput = dialog.querySelector('[data-mf-share-url]');
  const shareStatus = dialog.querySelector('[data-mf-share-status]');
  const shownHandles = () => shared === null ? saved : shared;
  const readShared = () => {
    if (!location.hash.startsWith('#mf-wishlist=')) return null;
    try {
      const payload = decodeURIComponent(location.hash.slice(13));
      if (!payload || payload.length > 52000) return [];
      const handles = payload.split(',');
      if (handles.length > 200 || handles.some(handle => !validHandle(handle) || handle.length > 255)) return [];
      return [...new Set(handles)];
    } catch { return []; }
  };
  const shareURL = () => {
    const url = new URL(root, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    url.hash = `mf-wishlist=${encodeURIComponent(shownHandles().join(','))}`;
    return url.href;
  };
  let generation = 0;
  const announce = message => { live.textContent = ''; requestAnimationFrame(() => { live.textContent = message; }); };
  const sync = () => {
    document.querySelectorAll('[data-mf-save]').forEach(button => {
      const active = saved.includes(button.dataset.mfSave);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? s.remove : s.add}: ${button.dataset.mfTitle || ''}`);
      const label = button.querySelector('[data-mf-save-label]');
      if (label && label.textContent !== (active ? s.saved : s.add)) label.textContent = active ? s.saved : s.add;
    });
    document.querySelectorAll('[data-mf-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-mf-count]').forEach(node => { if (node.textContent !== String(saved.length)) node.textContent = String(saved.length); node.hidden = saved.length === 0; });
    if (shareButton) shareButton.disabled = shownHandles().length === 0;
    dialog.querySelectorAll('[data-mf-copy]').forEach(button => { button.disabled = shownHandles().length === 0; });
    if (ownButton) ownButton.hidden = shared === null;
    if (title && title.textContent !== (shared === null ? ownTitle : s.shared_title)) title.textContent = shared === null ? ownTitle : s.shared_title;
    if (shareFallback && !shareFallback.hidden) shareInput.value = shareURL();
  };
  const toggle = handle => {
    if (!validHandle(handle)) return;
    const active = saved.includes(handle);
    const next = active ? saved.filter(value => value !== handle) : [...saved, handle];
    if (next.length > 200) { announce(s.limit); return; }
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(s.storage_error); if (dialog.open) status.textContent = s.storage_error; return; }
    saved = next;
    sync();
    announce(active ? s.remove : s.saved);
    if (dialog.open) {
      const previousIndex = saved.indexOf(handle);
      render().then(() => {
        if (!dialog.open) return;
        const buttons = list.querySelectorAll('[data-mf-save]');
        const target = buttons[Math.max(0, Math.min(previousIndex, buttons.length - 1))] || dialog.querySelector('[data-mf-close]');
        target.focus();
      });
    }
  };
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const productURL = handle => `${root}products/${encodeURIComponent(handle)}`;
  const render = async () => {
    const current = ++generation;
    const handles = [...shownHandles()];
    sync();
    list.replaceChildren();
    status.textContent = handles.length ? s.loading : s.empty;
    if (!handles.length) return;
    let failures = 0;
    const queue = [...handles];
    const slots = new Map(handles.map(handle => {
      const card = element('article', '', 'mf-wishlist-card');
      list.append(card);
      return [handle, card];
    }));
    const load = async handle => {
      const card = slots.get(handle);
      let product;
      let missing = false;
      try {
        const response = await fetch(`${productURL(handle)}.js`, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(10000) });
        if (response.status === 404) missing = true;
        else { if (!response.ok) throw new Error('Request failed'); product = await response.json(); }
      } catch { failures++; }
      if (current !== generation || !dialog.open) return;
      if (product && product.title) {
        const link = element('a');
        link.href = productURL(handle);
        if (product.featured_image) {
          const image = element('img');
          const src = new URL(product.featured_image, location.origin);
          if (src.protocol === 'https:') {
            src.searchParams.set('width', '480'); image.src = src.href;
            image.alt = product.title; image.loading = 'lazy'; image.width = 480; image.height = 640;
            link.append(image);
          }
        }
        link.append(element('h3', product.title));
        card.append(link);
        const currency = window.Shopify?.currency?.active || config.currency;
        card.append(element('p', new Intl.NumberFormat(document.documentElement.lang || 'is', { style: 'currency', currency }).format(product.price / 100)));
        if (!product.available) card.append(element('p', s.sold_out));
        const view = element('a', s.view); view.href = productURL(handle); card.append(view);
      } else {
        card.append(element('h3', handle.replace(/-/g, ' ')));
        card.append(element('p', missing ? s.unavailable : s.error));
        if (!missing) { const retry = element('button', s.retry); retry.type = 'button'; retry.addEventListener('click', render); card.append(retry); }
      }
      const remove = element('button', shared === null || saved.includes(handle) ? s.remove : s.add);
      remove.type = 'button'; remove.dataset.mfSave = handle;
      remove.dataset.mfTitle = product?.title || handle;
      const label = element('span', remove.textContent); label.dataset.mfSaveLabel = '';
      remove.replaceChildren(label);
      remove.setAttribute('aria-label', `${saved.includes(handle) ? s.remove : s.add}: ${product?.title || handle}`);
      card.append(remove);
    };
    await Promise.all(Array.from({ length: Math.min(4, queue.length) }, async () => {
      while (queue.length && current === generation && dialog.open) await load(queue.shift());
    }));
    if (current === generation && dialog.open) { status.textContent = failures ? s.error : ''; sync(); }
  };
  const fallback = async () => {
    shareFallback.hidden = false;
    shareInput.value = shareURL();
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(shareInput.value);
      shareStatus.textContent = s.copied;
    } catch {
      shareStatus.textContent = s.copy_hint;
      shareInput.focus(); shareInput.select();
    }
  };
  const share = async () => {
    if (!shownHandles().length) return;
    if (navigator.share) {
      try { await navigator.share({ title: s.share_title, text: s.share_text, url: shareURL() }); return; }
      catch (error) { if (error.name === 'AbortError') return; }
    }
    await fallback();
  };
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-mf-save]');
    if (save) { event.preventDefault(); event.stopPropagation(); toggle(save.dataset.mfSave); return; }
    if (event.target.closest('[data-mf-share]')) share();
    if (event.target.closest('[data-mf-copy]')) fallback();
    if (event.target.closest('[data-mf-own]')) { shared = null; shareFallback.hidden = true; render(); }
    if (event.target.closest('[data-mf-open]')) { shared = null; shareFallback.hidden = true; dialog.showModal(); render(); }
    if (event.target.closest('[data-mf-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => { generation++; });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    saved = decode(event.newValue); sync(); if (dialog.open) render();
  });
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  }).observe(document.getElementById('content'), { childList: true, subtree: true });
  sync();
  const openShared = () => {
    const handles = readShared();
    if (handles === null) return;
    shared = handles;
    shareFallback.hidden = true;
    if (!dialog.open) dialog.showModal();
    render();
  };
  window.addEventListener('hashchange', openShared);
  openShared();
})();
